import { ToastContainer, Slide } from 'react-toastify'
import { ErrorBoundary } from 'react-error-boundary'
import Home from '../pages/Home'
import FullScreenSpinner from 'src/components/FullScreenSpinner'
import FullscreenError from 'src/components/FullscreenError'
import 'react-toastify/dist/ReactToastify.css'
import BaseModal from 'src/components/modal/BaseModal'
import { useGetRunningContext} from 'src/hooks'
import OutOfMeetingHome from "../pages/OutOfMeetingHome";

function App() {
  const { isLoading, runningContext } = useGetRunningContext()

  const ErrorFallback = () => {
    return <FullscreenError />
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="text-sm font-medium font-SF h-screen sm:w-full">

        {isLoading && !runningContext ? (
          <FullScreenSpinner />
        ) : runningContext === 'inMainClient' ? (
            <OutOfMeetingHome />
        ) :runningContext === 'inMeeting' && (
          <Home />
        )}
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          transition={Slide}
          theme="light"
        />
        <BaseModal />
      </div>
    </ErrorBoundary>
  )
}

export default App
